// @ts-nocheck
import { useRole } from '@/contexts/RoleContext';
import { AdminInvitationsView } from '@/pages/admin/AdminInvitationsPage';

export default function TenantInvitationsPage() {
  const { isSuperAdmin, orgIds } = useRole();
  const orgId = orgIds[0]; // primary org
  return (
    <AdminInvitationsView
      scopeOrganizationId={orgId}
      callerIsSuperAdmin={isSuperAdmin}
      title="Staff invitations"
      subtitle="Invite staff to your organization."
    />
  );
}
